<div fxLayout="row" fxLayoutAlign="center">
  <h1>{{ title }}</h1>
</div>
<div fxLayout="row" fxLayoutAlign="center">
  <firebase-ui></firebase-ui>
</div>
